import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Issue } from '../../models/issue';
import { SettingsService } from '../../services/settings.service';
import { TaskDefinitionOfDone } from '../../models/taskDefinitionOfDone';
import { DefinitionOfDoneService } from '../../services/definition-of-done.service';
import { DefinitionOfDone } from '../../models/definitionOfDone';
import { ProjectService } from '../../services/project.service';
import { SynchronizationService } from '../../services/synchronization.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-popup-dod',
  templateUrl: './popup-dod.component.html',
  styleUrls: ['./popup-dod.component.scss']
  })
export class PopupDodComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() issueInput: Issue;
  @Input() loadedFromIssue: boolean;
  public _issue: Issue;
  public issueContainer: Array<any>;
  private projectName: string;
  private projectId: number;
  public dodHasBeenChanged = false;
  private event: Subscription[] = [];


  // All DoD's for this project
  public definitionOfDones: DefinitionOfDone[] = [];

  // Contains a TaskDefinitionOfDone-Object which contains all DoD-ID's for a specific task
  public taskDods: TaskDefinitionOfDone;
  private disabledDoD: TaskDefinitionOfDone;

  constructor(
    private settingsService: SettingsService,
    private elementRef: ElementRef,
    private projectService: ProjectService,
    private syncService: SynchronizationService,
    private definitionOfDoneService: DefinitionOfDoneService
  ) {
  }

  ngOnInit() {
    if (this.issueInput) {
      this._issue = this.issueInput;
    }
    this.loadInfo();
    this.setupRealTimeEvents();
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
  }

  ngAfterViewChecked(): void {
    if (this.loadedFromIssue) {
      const divLeftBlock: any = document.getElementById('id_dod_popup' + this.issueInput.id);
      if (divLeftBlock) {
        divLeftBlock.classList.remove('mat-card');
      }
    }
  }

  loadInfo() {
    this.projectName = this.settingsService.getProjectName();
    this.projectService.getProjectByKey(this.projectName).subscribe(val => {
      this.projectId = val.id;
      this.loadData();
    });
  }

  loadData() {
    if (this.projectId) {
      this.definitionOfDoneService.getDefinitionOfDone(this.projectId, false).subscribe(value => {
        this.definitionOfDones = [];
        for (const dod of value) {
          if (dod.active) {
            this.definitionOfDones.push(dod);
          }
        }
        this.definitionOfDoneService.getDefinitionOfDoneForTask(this.projectId, this._issue.id).subscribe(data => {
          this.taskDods = data;
        });
      });
    } else {
      this.closeThisCard();
    }
  }

  private setupRealTimeEvents() {
    this.event.push(this.syncService.subscribeEvent<any>('UpdateDodDone' + this._issue.id)
      .subscribe(data => {
        // TODO - dublicated code (Check onTaskDodChanged)
        for (const entry of this.taskDods.definition_of_dones_id) {
          if (entry.definition_of_done_id === data.dodId) {
            entry.set_done = data.value;
          }
        }
        this.dodHasBeenChanged = true;
      }));
    this.event.push(this.syncService.subscribeEvent<any>('UpdateDodNotRelevant' + this._issue.id)
      .subscribe(data => {
        // TODO - dublicated code (check relevantChanged)
        for (const entry of this.taskDods.definition_of_dones_id) {
          if (entry.definition_of_done_id === data.dodId) {
            if (entry.not_relevant === false) {
              entry.not_relevant = true;
              entry.set_done = false;
            } else {
              entry.not_relevant = false;
            }
          }
        }
        this.dodHasBeenChanged = true;
      }));
  }

  /**
   * Checks if this dod is active/selected for the task
   */
  isActiveSet(dod: DefinitionOfDone): boolean {
    let isSet = false;
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dod.id) {
        isSet = entry.set_done;
      }
    }
    return isSet;
  }

  /**
   * Checks if dod is relevant for this task
   */
  isRelevantSet(dod: DefinitionOfDone): boolean {
    let isRelevant = false;
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dod.id && entry.not_relevant) {
        isRelevant = true;
      }
    }
    return isRelevant;
  }

  /**
   * Checkbox has been toggled. Remove or add the DoD to the task.
   */
  onTaskDodChanged(dod) {
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dod.id) {
        if (entry.set_done === false) {
          entry.set_done = true;
          this.syncService.sendRealTimeEvent(
            'UpdateDodDone' + this._issue.id, { 'dodId': dod.id, 'issueId': this._issue.id, 'value': true }
          );
        } else {
          entry.set_done = false;
          this.syncService.sendRealTimeEvent(
            'UpdateDodDone' + this._issue.id, { 'dodId': dod.id, 'issueId': this._issue.id, 'value': false }
          );
        }
      }
    }
    this.dodHasBeenChanged = true;
  }

  /**
   * relevant has been toggled. Adjust data struct according to the event
   */
  relevantChanged(dod) {
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dod.id) {
        if (entry.not_relevant === false) {
          entry.not_relevant = true;
          entry.set_done = false;
          this.syncService.sendRealTimeEvent(
            'UpdateDodNotRelevant' + this._issue.id, { 'dodId': dod.id, 'issueId': this._issue.id, 'value': false }
          );
        } else {
          entry.not_relevant = false;
          this.syncService.sendRealTimeEvent(
            'UpdateDodNotRelevant' + this._issue.id, { 'dodId': dod.id, 'issueId': this._issue.id, 'value': false }
          );
        }
      }
    }
    this.dodHasBeenChanged = true;
  }

  /**
   * Checks if active for task needs to be disabled
   * -> if not relevant is tickked, active for task gets disabled
   */
  checkDisabled(dod) {
    let disable = false;
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dod.id) {
        if (entry.not_relevant) {
          disable = true;
        }
      }
    }
    return disable;
  }

  /**
   * Checks if a dod was already set and disables the checkbox
   * @param dod
   */
  isPreSet(dod) {
    let isSet = false;
    if (this.disabledDoD) {
      for (const entry of this.disabledDoD.definition_of_dones_id) {
        if (entry.definition_of_done_id === dod.id) {
          isSet = true;
        }
      }
    }
    return isSet;
  }

  saveChanges() {
    if (this.dodHasBeenChanged) {
      this.definitionOfDoneService.addDefinitionOfDoneForTask(this.projectId, this._issue.id, this.taskDods).subscribe();
    }
    if (!this.issueInput) {
      this.closeThisCard();
    }
  }

  closeThisCard() {
    this.definitionOfDoneService.emitRemoveDoDPopUp(this._issue);
    this.syncService.sendRealTimeEvent('ClosePopup', { 'id': this._issue.id });
  }

  /**
   * Returns an ElementReference to the host-element of this component for DOM-access
   */
  getElementRef(): ElementRef {
    return this.elementRef;
  }

  /**
   * Sets the task for this issuecard and triggers loading of additional task information (attachments)
   */
  public set issue(issue: Issue) {
    this._issue = issue;
  }

  public get issue() {
    return this._issue;
  }

  // TODO - obsolete -> delete
  public updateSetDod(dodId) {
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dodId) {
        entry.set_done = !entry.set_done;
      }
    }
  }

  // TODO - obsolete -> delete
  public updateSetNotRelevant(dodId) {
    for (const entry of this.taskDods.definition_of_dones_id) {
      if (entry.definition_of_done_id === dodId) {
        entry.not_relevant = !entry.not_relevant;
        if (entry.not_relevant) {
          entry.set_done = false;
        }
      }
    }
  }

  // /* This is the new approach with relativ position-values */
  // private initPopupMovedSubscription(taskboard: TaskboardViewComponent) {
  //   taskboard.subscriptions.push(this.syncService.subscribeEvent<any>('PopupMoved').subscribe(data => {
  //     const popup = taskboard.getPopup(data.issueId);
  //
  //     if (popup) {
  //       console.log('rte moving popup', data);
  //       const target = popup.getElementRef().nativeElement;
  //       const translateX = document.documentElement.clientWidth * data.percentFromLeft / 100;
  //       const translateY = (document.documentElement.clientHeight * data.percentFromTop / 100);
  //       console.log('data-x', '' + translateX);
  //       console.log('data-y', '' + translateY);
  //
  //       target.style.webkitTransform = 'translate(' + translateX + 'px, ' + translateY + 'px)';
  //       target.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px)';
  //       target.setAttribute('data-x', '' + translateX);
  //       target.setAttribute('data-y', '' + translateY);
  //     }
  //   }));
  // }

}
